module.exports = __webpack_public_path__ + "ui-static/img/external-detectors-no-items_dark.fa31c71a.svg";